export const timeCardTypes = {
  standard: 1,
  break: 2,
  other: 3,
};
